import qoalaStorage from '~/core/Storage';

export default () => ({
  loader: false,
  modalMessage: false,
  message: {},
  searchPolis: null,
  listBank: JSON.parse(qoalaStorage.getItem('banks')),
  pin: JSON.parse(qoalaStorage.getItem('pin')),
  otpStatus: JSON.parse(qoalaStorage.getItem('otpStatus')),
  notifHome: JSON.parse(qoalaStorage.getItem('notifHome')),
  profileView: 'default',
  calledOnce: false,
  firstTime: JSON.parse(qoalaStorage.getItem('activeFirstTime')),
  pdfLink: qoalaStorage.getItem('pdfLink'),
  a2hs: JSON.parse(qoalaStorage.getItem('A2HS')),
  volumeUp: '',
  volumeDown: '',
  countryCode: JSON.parse(qoalaStorage.getItem('country')),
  localeLanguage: qoalaStorage.getItem('localeLanguage'),
  pickUpDates: '',
  addressData: {
    province: [],
    city: [],
    district: [],
    village: []
  },
  loginData: JSON.parse(qoalaStorage.getItem('loginData')),
  articles: [],
  detailArticle: {
    title: {
      rendered: 'Qoala'
    },
    excerpt: {
      rendered: 'Insurtech'
    },
    jetpack_featured_media_url: ''
  },
  promos: [],
  // userPhone: {
  //   phoneBrand: [],
  //   phoneModel: []
  // },
  purchaseHistory: qoalaStorage.getItem('purchaseHistory'),
  detailPromo: {},
  transactionHistory: qoalaStorage.getItem('transactionHistory'),
  transactionHistoryDetail: qoalaStorage.getItem('transactionHistoryDetail'),
  activeTransaction: JSON.parse(qoalaStorage.getItem('activeTransaction')),
  insurancePartner: [],
  comparedProduct: qoalaStorage.getItem('comparedProduct'),
  guest: qoalaStorage.getItem('guest'),
  snapToken: qoalaStorage.getItem('snapToken')
});
